import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSlideToggleChange, PageEvent, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { CategoryService } from 'src/services/category.service';
import { MessageService } from 'src/services/message.service';
import { AlertDeleteComponent } from '../shared/alert-delete/alert-delete.component';
import { MarkerService } from 'src/services/marker.service';
import { TypeService } from 'src/services/type.service';
import { IconService } from 'src/services/icon.service';
import * as firebase from 'firebase/app';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-marker',
  templateUrl: './marker.component.html',
  styleUrls: ['./marker.component.scss']
})
export class MarkerComponent implements OnInit {
  displayedColumns: string[] = ['select', 'nro', 'name', 'siteweb', 'numberphone', 'icon', 'latitude', 'longitude', 'type', 'options'];
  dataSource: MatTableDataSource<CategoryElement>;
  dataList = [];
  items: Array<any>;
  selection = new SelectionModel<CategoryElement>(true, []);
  color = "primary";
  checked = false;
  // MatPaginator Output
  //Save first document in snapshot of items received
  firstInResponse: any = [];

  //Save last document in snapshot of items received
  lastInResponse: any = [];
  //Keep the array of first document of previous pages
  prev_strt_at: any = [];

  //Maintain the count of clicks on Next Prev button
  pagination_clicked_count = 0;

  //Disable next and prev buttons
  disable_next: boolean = false;
  disable_prev: boolean = false;
  // MatPaginator Output
  pageEvent: PageEvent;
  length = 5;
  pageSize = 5;
  pageIndex: number = 0;

  // List
  listIcons=[];
  listTypes=[];
  listCategory=[];
  user_json={};


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(public markerService: MarkerService, public dialog: MatDialog, public messageService: MessageService,
    public categoryService: CategoryService, public typeService:TypeService,
    public iconService: IconService,public auth: AuthService) {
      auth.user$.subscribe((res) => {
        if (res) {
          this.user_json = {
            uid: res['uid'],
            name: res['email']
          }
        }
  
      })
     }


  ngOnInit() {
    this.getCount();
    this.getAll(this.pageSize);
    this.getCatgory();
    this.getType();
    this.getIcons();
  }
  listCategories() {
    this.getCount();
    this.getAll(this.pageSize)
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    if (this.dataSource) {
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }
  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: CategoryElement): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  getCount() {
    this.markerService.getCount().subscribe(result => {
      // this.length = result['page_size'];
      this.length = result.size;
    });
  }
  getAll(limit) {
    this.markerService.getMarkersAll(limit).subscribe(result => {
      this.dataList = [];
      if (!result.length) {
        return false;
      }
      this.firstInResponse = result[0].payload.doc;
      this.lastInResponse = result[result.length - 1].payload.doc;
      this.items = result;
      result.forEach(r => {
        console.log('result', r.payload.doc.data())
        this.dataList.push({
          id: r.payload.doc.id,
          name: r.payload.doc.data()['name'],
          code: r.payload.doc.data()['code'],
          coordinates: r.payload.doc.data()['coordinates'],
          icon: r.payload.doc.data()['icon'],
          latitude: r.payload.doc.data()['latitude'],
          longitude: r.payload.doc.data()['longitude'],
          number_phone: r.payload.doc.data()['number_phone'],
          site_web: r.payload.doc.data()['site_web'],
          type_category: r.payload.doc.data()['type_category'],
          user_id: r.payload.doc.data()['user_id'],
          user_name: r.payload.doc.data()['user_name'],
          address: r.payload.doc.data()['address'],
        })
      })
      //Initialize values
      this.prev_strt_at = [];
      this.pagination_clicked_count = 0;
      this.disable_next = false;
      this.disable_prev = false;

      //Push first item to use for Previous action
      this.push_prev_startAt(this.firstInResponse);

      this.dataSource = new MatTableDataSource(this.dataList);
    })
  }
  pageLoad($event) {
    if ($event.pageIndex === this.pageIndex + 1) {
      this.nextPage($event.pageSize);
    } else if ($event.pageIndex === this.pageIndex - 1) {
      this.prevPage($event.pageSize);
    }
    else {
      this.getAll($event.pageSize);
    }
    this.pageIndex = $event.pageIndex;

  }
  //Show previous set 
  prevPage(pagesize) {
    this.disable_prev = true;
    this.markerService.getPrevPageMarkers(this.get_prev_startAt(), this.firstInResponse, pagesize).subscribe(response => {
      this.firstInResponse = response.docs[0];
      this.lastInResponse = response.docs[response.docs.length - 1];
      this.dataList = [];
      response.docs.forEach(r => {
        this.dataList.push({
          id: r.id,
          name: r.data()['name'],
          code: r.data()['code'],
          coordinates: r.data()['coordinates'],
          icon: r.data()['icon'],
          latitude: r.data()['latitude'],
          longitude: r.data()['longitude'],
          number_phone: r.data()['number_phone'],
          site_web: r.data()['site_web'],
          type_category: r.data()['type_category'],
          user_id: r.data()['user_id'],
          user_name: r.data()['user_name'],
          address: r.data()['address'],
        })

      })
      //Maintaing page no.
      this.pagination_clicked_count--;

      //Pop not required value in array
      this.pop_prev_startAt(this.firstInResponse);

      //Enable buttons again
      this.disable_prev = false;
      this.disable_next = false;
      this.dataSource = new MatTableDataSource(this.dataList);

    }, error => {
      this.disable_prev = false;
    });
  }
  nextPage(pagesize) {
    this.disable_next = true;
    this.markerService.getNextPageMarkers(pagesize, this.lastInResponse).subscribe(response => {

      if (!response.docs.length) {
        this.disable_next = true;
        return;
      }

      this.firstInResponse = response.docs[0];

      this.lastInResponse = response.docs[response.docs.length - 1];

      this.dataList = [];
      response.docs.forEach(r => {
        this.dataList.push({
          id: r.id,
          name: r.data()['name'],
          code: r.data()['code'],
          coordinates: r.data()['coordinates'],
          icon: r.data()['icon'],
          latitude: r.data()['latitude'],
          longitude: r.data()['longitude'],
          number_phone: r.data()['number_phone'],
          site_web: r.data()['site_web'],
          type_category: r.data()['type_category'],
          user_id: r.data()['user_id'],
          user_name: r.data()['user_name'],
          address: r.data()['address'],
        })

      })

      this.pagination_clicked_count++;

      this.push_prev_startAt(this.firstInResponse);

      this.disable_next = false;
      this.dataSource = new MatTableDataSource(this.dataList);
    }, error => {
      this.disable_next = false;
    });
  }
  //Add document
  push_prev_startAt(prev_first_doc) {
    this.prev_strt_at.push(prev_first_doc);
  }
  //Remove not required document 
  pop_prev_startAt(prev_first_doc) {
    this.prev_strt_at.forEach(element => {
      if (prev_first_doc.data().id == element.data().id) {
        element = null;
      }
    });
  }
  //Return the Doc rem where previous page will startAt
  get_prev_startAt() {
    if (this.prev_strt_at.length > (this.pagination_clicked_count + 1))
      this.prev_strt_at.splice(this.prev_strt_at.length - 2, this.prev_strt_at.length - 1);
    return this.prev_strt_at[this.pagination_clicked_count - 1];
  }


  openDialog(): void {
    let data_obj = {
      title:'Nuevo',
      name: '',
      code: '',
      coordinates: {},
      icon: '',
      latitude: '',
      longitude: '',
      number_phone: '',
      site_web: '',
      type_category: '',
      address: '',
      icons: this.listIcons,
      categories:this.listCategory
    };

    const dialogRef = this.dialog.open(modalMarkerComponent, {
      width: '80%',
      data: data_obj,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    console.log("MarkerComponent -> openDialog -> result", result)
      if (result) {
        if (result['name'] != '' && result['code'] != '' && result['address'] != '' && result['latitude'] != '' && result['longitude'] != '' && result['number_phone'] != '' && result['site_web'] != '' && result['type_category'] != '') {
          let icon = result['icons'].filter(res => res['code'] === result['code']);
          const data = {
            name: result['name'],
            number_phone: result['number_phone'],
            site_web: result['site_web'],
            latitude: result['latitude'],
            longitude: result['longitude'],
            code: result['code'],
            type_category: result['type_category'],
            user_id: this.user_json['uid'],
            user_name: this.user_json['name'],
            icon: icon[0]['url_icon'],
            address: result['address'],
            coordinates: new firebase.firestore.GeoPoint(Number(result['latitude']), Number(result['longitude']))
          };
          this.markerService.createMarkers(data).then(res => {
            this.getCount();
            this.getAll(this.pageSize);
            this.messageService.open({ message: 'Registro Realizado con éxito', addExtraClass: ['alert-success'] });
          })

        } else {
          this.messageService.open({ message: 'No se realizó el registro, Valores vacios', addExtraClass: ['alert-error'] });
          this.getCount();
          this.getAll(this.pageSize);
        }
      } else {
        this.messageService.open({ message: 'Se cancelo!', addExtraClass: ['alert-info'] });
        this.getCount();
        this.getAll(this.pageSize);
      }
    }, err =>{
      this.messageService.open({ message: 'Problemas con el registro de la informacion', addExtraClass: ['alert-error'] });
    });
  }
  editDialog(data): void {
    data['title'] = "Editar"
    data['icons']= this.listIcons;
    data['types']=this.listTypes;
    data['categories']=this.listCategory;
    const dialogRef = this.dialog.open(modalMarkerComponent, {
      width: '80%',
      data: data,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('resultresult',result)
      if (result) {
        const data = {
          name: result['name'],
          number_phone: result['number_phone'],
          site_web: result['site_web'],
          latitude: result['latitude'],
          longitude: result['longitude'],
          code: result['code'],
          type_category: result['type_category'],
          user_id: this.user_json['uid'],
          user_name: this.user_json['name'],
          icon: result['icon'],
          address: result['address'],
          coordinates: new firebase.firestore.GeoPoint(Number(result['latitude']), Number(result['longitude']))
        };
        this.markerService.updateMarkers(result['id'],data).then(res => {
          this.getCount();
          this.getAll(this.pageSize);
          this.messageService.open({ message: 'Se realizo la actualizacion:', addExtraClass: ['alert-success'] });
        })
      } else {
        this.messageService.open({ message: 'Se cancelo!', addExtraClass: ['alert-info'] });
        this.getCount();
        this.getAll(this.pageSize);
      }
    });
  }
  deleteMarker(data) {
    data['title'] = "¿Desea eliminar el registro?";
    data['message'] = "Se eliminara el registro: " + data['name'];
    const dialogRef = this.dialog.open(AlertDeleteComponent, {
      width: '50%',
      data: data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const ids = [];
        ids.push(result)
        this.markerService.deleteMarkers(ids);
        this.getCount();
        this.getAll(this.pageSize);
        this.messageService.open({ message: 'Se eliminó con exito', addExtraClass: ['alert-success'] });
      } else {
        this.messageService.open({ message: 'Se cancelo!', addExtraClass: ['alert-info'] });
      }
    });
  }
  deleteAll(){
    console.log('deleteee')
    // this.markerService.deleteAllMarkers();
  }
  getCatgory(){
    this.listCategory=[];
    this.categoryService.getCategoryState(true).subscribe(r=>{
      console.log('r categories',r);
      this.listCategory=r;
    })
  };
  getType(){
    this.listTypes=[];
    this.typeService.getTypeState(true).subscribe(r=>{
      console.log(' typeee', r);
      this.listTypes=r;
    })
  }
  getIcons(){
    this.listIcons=[];
    this.iconService.getIconState(1).subscribe(r=>{
      console.log(' icons', r);
      this.listIcons=r;
    })
  }
  applyFilter(event: Event) {
    
    const filterValue = (event.target as HTMLInputElement).value;
    this.markerService.searchMarker(filterValue,this.pageSize).subscribe(response =>{
      this.dataList = [];
      response.docs.forEach(r =>{
        this.dataList.push({
          id: r.id,
          name: r.data()['name'],
          code: r.data()['code'],
          coordinates: r.data()['coordinates'],
          icon: r.data()['icon'],
          latitude: r.data()['latitude'],
          longitude: r.data()['longitude'],
          number_phone: r.data()['number_phone'],
          site_web: r.data()['site_web'],
          type_category: r.data()['type_category'],
          user_id: r.data()['user_id'],
          user_name: r.data()['user_name'],
          address: r.data()['address'],
        });
      })
      // this.length = response.docs.length;
      this.dataSource = new MatTableDataSource(this.dataList);
      
    });
    // this.dataSource.filter = filterValue.trim().toLowerCase();

    // if (this.dataSource.paginator) {
    //   this.dataSource.paginator.firstPage();
    // }
  }

}
export interface CategoryElement {
  id: string;
  name: string;
  code: string;
  coordinates: object;
  icon: string;
  latitude: string;
  longitude: string;
  number_phone: number;
  site_web: string;
  type_category: string;
  user_id: string;
  user_name: string;
  address: string;
  title:string;
  icons:[];
  categories:[];
}
@Component({
  selector: 'dialog-marker',
  templateUrl: 'marker.dialog.html',
  styleUrls: ['marker.component.scss']
})
export class modalMarkerComponent{

  constructor(
    public dialogRef: MatDialogRef<modalMarkerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }
  

  onNoClick(): void {
    this.dialogRef.close();
  }
  

}

export interface DialogData {
  id: string;
  name: string;
  code: string;
  coordinates: object;
  icon: string;
  latitude: string;
  longitude: string;
  number_phone: number;
  site_web: string;
  type_category: string;
  user_id: string;
  user_name: string;
  address: string;
  title:string;
  icons:[];
  categories:[];
}
